import { actionsCell, dateCell, nameCell } from "./documentTableCells";
import { Flex, Td, Tr } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { displayDateWithTime } from "../formatting/displayDateWithTime";
import { Explanation } from "../support/Explanation/Explanation";
import { DownloadDocumentIconButton } from "./DownloadDocumentIconButton/DownloadDocumentIconButton";
import { PreviewDocumentButton } from "./PreviewDocumentButton";
import { AnnouncementAttachment, getFileExtension, isPdfExtension } from "./utils";

export const AnnouncementAttachmentRow = ({
  doc,
  isTagsColumnVisible,
  isCategoryColumnVisible,
  isCreatedByColumnVisible,
}: {
  doc: AnnouncementAttachment;
  isTagsColumnVisible: boolean;
  isCategoryColumnVisible: boolean;
  isCreatedByColumnVisible: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Tr>
      <Td px="3" {...nameCell}>
        {isPdfExtension(getFileExtension(doc.name)) ? (
          <PreviewDocumentButton documentId={doc.id} documentName={doc.name} eventId={doc.eventId} />
        ) : (
          doc.name
        )}
      </Td>
      <Td fontSize="sm" {...dateCell}>{displayDateWithTime(doc.publishedAt)}</Td>
      {isCreatedByColumnVisible && <Td />}
      {isTagsColumnVisible && <Td />}
      {isCategoryColumnVisible && <Td />}
      <Td {...actionsCell}>
        <Flex justifyContent="end">
          <Explanation text={t("Download document")} shouldWrapChildren>
            <DownloadDocumentIconButton documentId={doc.id} eventId={doc.eventId} />
          </Explanation>
        </Flex>
      </Td>
    </Tr>
  );
};
